import React from "react";
import styled from "styled-components";
import { bool, func, object as obj, oneOfType, string } from "prop-types";
import ErrorMessage from "components/onboarding/components/OnboardingErrorMessage";
import tick from "icons/tick.svg";

const CheckboxWrapper = styled.div`
  display: inline-block;
  position: relative;
  min-height: 25px;
  margin: 10px 0px;
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;

  &.smallText {
    font-size: 13px;
    line-height: 21px;
  }

  @media (min-width: ${props => props.theme.desktopWidth}) {
    margin: 10px 20px;

    &.smallText {
      font-size: 13px;
      line-height: 18px;
    }
  }
`;

const CheckboxLabel = styled.label`
  display: inline-block;
  color: ${props => props.theme.colors.formText};
  vertical-align: top;
  margin-left: 35px;
  text-align: left;
  user-select: none;
  cursor: pointer;
  line-height: 25px;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  display: inline-block;
  position: absolute;
  width: 25px;
  height: 25px;
  margin: 0px;
  border-width: 1px;
  opacity: 0.01;
  z-index: 1;
  cursor: pointer;

  &:focus + div {
    box-shadow: 0px 2px 10px 2px ${props => props.theme.colors.shadowGrey};
  }
`;

const CheckboxDisplay = styled.label`
  cursor: pointer;
  display: inline-block;
  position: absolute;
  left: 1px;
  width: 25px;
  height: 25px;
  border: 2px solid
    ${({ error, theme }) =>
      error ? theme.colors.statusRed : theme.colors.grey};
  border-radius: 4px;
  color: transparent;
  margin-left: -1px;
  text-align: center;
  z-index: 0;

  &.filled {
    background: url(${tick}) no-repeat center;
    background-size: 105% 110%;
    border-color: ${props => props.theme.colors.basicBlue};
  }

  &.error {
    border-color: ${props => props.theme.colors.warningRed};
  }
`;

const OnboardingCheckbox = ({
  checked,
  className,
  error,
  label,
  name,
  onBlur,
  onChange
}) => (
  <div>
    <CheckboxWrapper className={className}>
      <Checkbox
        name={name}
        checked={checked}
        onBlur={onBlur}
        onChange={onChange}
      />
      <CheckboxDisplay
        error={error}
        htmlFor={name}
        className={checked ? "filled" : ""}
      />
      {label && <CheckboxLabel htmlFor={name}>{label}</CheckboxLabel>}
    </CheckboxWrapper>
    {error && <ErrorMessage error={error} padding="0 20px" />}
  </div>
);

OnboardingCheckbox.propTypes = {
  checked: bool.isRequired,
  className: string,
  error: string,
  label: oneOfType([string, obj]),
  name: string.isRequired,
  onBlur: func,
  onChange: func
};

export default OnboardingCheckbox;
